<mat-card *ngIf="role" appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1 i18n>Edit {{ role.title }}</h1>
      <eas-translation-info-list *ngIf="role.doc.translationInfo" [translationInfo]="role.doc.translationInfo">
      </eas-translation-info-list>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-form-default [formData$]="formData$" (submitted)="onSubmit()"></app-form-default>
  </mat-card-content>
</mat-card>
